import React from "react";
import "./modalForm.css";

export function ModalAlert({ handleClose, titulo, children, contentStyle = {}, maxWidth = 1000, maxHeight = "90vh", visibility, showModal = true, estiloTitulo = {} }) {

    if (!showModal || (!titulo && !children)) return null;
  
    return (
        <div style={{ visibility: visibility || "visible" }}>
            <div className="modal">
                <div className="modal-content" style={{ maxWidth, maxHeight, overflow: "auto", justifyContent: "flex-start" }}>
                    {handleClose ? (
                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <button className="close-button" style={{ outline: "none" }} type="button" onClick={handleClose}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                    ) : null}
                    <h5 style={{ textAlign: "center", ...estiloTitulo }}>{titulo}</h5>
                    <div style={contentStyle}>{children}</div>
                </div>
            </div>
        </div>
    );
}
